module.exports = __webpack_public_path__ + "media/images/pic/hero/courses/school/early-school-ef0d643d599b6b734105b83f9e53a27b.jpeg";